// ReduxGuestCartReducer.js

import CreateCartSlice from "../utils/common/CreateCartSlice";

const guestCartSlice = CreateCartSlice("guestCart");

export const {
  setUserRefCode: setGuestUserRefCode,
  addItemToCart: addGuestItemToCart,
  removeItemFromCart: removeGuestItemFromCart,
  increaseItemQuantity: increaseGuestItemQuantity,
  decreaseItemQuantity: decreaseGuestItemQuantity,
  updateItemQuantity: updateGuestItemQuantity,
  clearCart: clearGuestCart,
} = guestCartSlice.actions;

export default guestCartSlice.reducer;
